module.exports = {
  API_URL: 'https://egglesscake-backend.fly.dev'
};